import NegotiationItem from "./NegotiationItem";


export default function NegotiationDetails() {
    return <>
        <NegotiationItem />
    </>
}